const TemplateNews = {
  init() {
    TemplateNews.select();
  },

  select() {
    // Open
    $("body").on("click", ".selectric__main", function () {
      $(this).parent().toggleClass("selectric--open");
    });

    // Close
    $(document).mouseup(function (e) {
      let container = $(".selectric");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("selectric--open");
      }
    });

    // Select option
    $("body").on("click", ".selectric__option-inner", function () {
      let option = $(this);
      let wrapper = option.closest(".selectric");

      wrapper.children("select").val(option.data("id")).trigger("change");

      wrapper.removeClass("selectric--open");
    });

    $("body").on("change", ".selectric select", function () {
      let val = $(this).val();
      let wrapper = $(this).parent();
      let found = wrapper.find(".selectric__option-inner[data-id=" + val + "]");
      wrapper.find(".selectric__main span").text(found.text());
    });
  },
};

export default TemplateNews;
